export enum LegalSourceIncome {
    ACTIVITY = '1D',
    SALE = '2D',
    OTHER = '3D',
}
